import services from '@/http';
import { user } from '@/http';
import * as types from './mutation-types';
import flashMessages from '@/utils/flash-messages';

export const ActionDownloadBoleto = ( _, payload) => {
    user.downloadBoleto.data = payload;
    return services.http.request(user.downloadBoleto)
        .then((response) => response.data?.results)
        .catch((error) => {
            if (error.data?.message) {
                flashMessages.error(error.data.message);
            }
            throw error;
        });
}

export const ActionLogDownloadBoleto = (_, payload = {}) => {
    user.logDownloadBoleto.data = {
        IP: payload.IP || '',
        OS: payload.OS || (typeof navigator !== 'undefined' ? navigator.platform : ''),
        UserID: payload.UserID ?? localStorage.getItem('UserID'),
        UserFullName: payload.UserFullName,
        tag: payload.tag ?? localStorage.getItem('tag'),
        contrato: payload.contrato || payload.contract || undefined,
        digitableLine: payload.digitableLine || payload.LinhaDigitavel || undefined,
        credor: payload.credor || undefined,
        NotesJson: payload.NotesJson || undefined,
    };

    return services.http.request(user.logDownloadBoleto)
        .then((response) => response.data?.results)
        .catch((error) => {
            console.warn('[tribanco] Log Efetuou Download Boleto ignorado:', error);
            return null;
        });
}

export const ActionLogCopyDigitableLine = (_, payload = {}) => {
    user.logCopyDigitableLine.data = {
        IP: payload.IP || '',
        OS: payload.OS || (typeof navigator !== 'undefined' ? navigator.platform : ''),
        UserID: payload.UserID ?? localStorage.getItem('UserID'),
        UserFullName: payload.UserFullName,
        tag: payload.tag ?? localStorage.getItem('tag'),
        contrato: payload.contrato || payload.contract || undefined,
        digitableLine: payload.digitableLine || payload.LinhaDigitavel || undefined,
        credor: payload.credor || undefined,
        NotesJson: payload.NotesJson || undefined,
    };

    return services.http.request(user.logCopyDigitableLine)
        .then((response) => response.data?.results)
        .catch((error) => {
            console.warn('[tribanco] Log Copiou Linha Digitável ignorado:', error);
            return null;
        });
}

export const ActionSendEmailOrSmsText = (context, payload) => {
    const type = payload.type;
    delete payload.type;
    user.sendSmsOrEmail.data = payload;
    
    return services.http.request(user.sendSmsOrEmail)
        .then((response) => response)
        .catch((error) => {
            const typeMessage = {
                sms: 'Ocorreu um erro ao tentar enviar o SMS, tente novamente mais tarde',
                email: 'Ocorreu um erro ao tentar enviar o e-mail, tente novamente mais tarde',
            }
            const message = typeMessage[type] || 'Não foi possível executar a ação, tente novamente mais tarde';
            flashMessages.error(message, 'Erro');
            throw error;
        });
}

export const ActionGetDebtsTribanco = ( _, payload) => {
    user.getDebtsTribanco.data = payload;
    return services.http.request(user.getDebtsTribanco)
        .then((response) => response.data?.results)
        .catch((error) => {
            if (error.data?.message) {
                flashMessages.error(error.data.message);
            }
            throw error;
        })
}


export const ActionGetInvoicesTribanco = () => {
    return services.http.request(user.getInvoicesTribanco)
        .then((response) => response.data?.results)
        .catch((error) => {
            if (error.data?.message) {
                flashMessages.error(error.data.message);
            }
            throw error;
        })
}

export const ActionViewAgreementsTribanco = (_, payload = {}) => {
    user.viewAgreementsTribanco.data = {
        IP: payload.IP || '',
        OS: payload.OS || (typeof navigator !== 'undefined' ? navigator.platform : ''),
        UserID: payload.UserID ?? localStorage.getItem('UserID'),
        UserFullName: payload.UserFullName,
        tag: payload.tag ?? localStorage.getItem('tag'),
        agreementsCount: payload.agreementsCount ?? 0,
        agreements: payload.agreements || undefined,
        NotesJson: payload.NotesJson || undefined,
    };

    return services.http.request(user.viewAgreementsTribanco)
        .then((response) => response.data?.results)
        .catch((error) => {
            // Log não deve interromper a tela Meus Acordos
            console.warn('[tribanco] Log Visualizou Acordo ignorado:', error);
            return null;
        });
}

export const ActionGetInstallmentsTribanco = ( _, payload) => {
    user.getInstallmentsTribanco.data = payload;
    return services.http.request(user.getInstallmentsTribanco)
        .then((response) => response.data?.results)
        .catch((error) => {
            if (error.data?.message) {
                flashMessages.error(error.data.message);
            }
            throw error;
        })
}

export const ActionGetOffersTribanco = ( _, payload) => {
    user.getOffersTribanco.data = payload;
    return services.http.request(user.getOffersTribanco)
        .then((response) => response.data?.results)
        .catch((error) => {
            if (error.data?.message) {
                flashMessages.error(error.data.message);
            }
            throw error;
        });
}

export const ActionSetAgreement = ( _,payload) => {
    user.getAgreementTribanco.data = payload;
    return services.http.request(user.getAgreementTribanco)
        .then((response) => response.data?.results).catch((error) => {
            if (error.data?.message) {
                flashMessages.error(error.data.message);
            }
            throw error;
        })
}

export const ActionGetOptionsInstallments = ( _, payload) => {
    user.optionsInstallments.data = payload;
    return services.http.request(user.optionsInstallments)
        .then((response) => response.data?.results)
        .catch((error) => {
            if (error.data?.message) {
                flashMessages.error(error.data.message);
            }
            throw error;
        });
}

export const ActionDownloadBoletoSegundaVia = ( _, payload) => {
    user.downloadBoletoSegundaVia.data = payload;
    return services.http.request(user.downloadBoletoSegundaVia)
        .then((response) => response.data?.results)
        .catch((error) => {
            if (error.data?.message) {
                flashMessages.error(error.data.message);
            }
            throw error;
        });
}

export const ActionSendProposalTribancoEmail = ( _, payload) => {
    user.sentProposalTribanco.data = payload;
    return services.http.request(user.sentProposalTribanco)
        .then((response) => response.data?.results)
        .catch((error) => {
            if (error.data?.message) {
                flashMessages.error(error.data.message);
            }
            throw error;
        })
}



// commit é responsável por chamar a mutation
export const ActionSetContractsNegotiable = ({ commit }, contracts) => {
    commit(types.SET_NEGOTIABLE, contracts);
}

// commit é responsável por chamar a mutation
export const ActionSetParcelamentSelected = ({ commit }, parcelament) => {
    commit(types.SET_PARCELAMNENT_SELECTED, parcelament);
}

// commit é responsável por chamar a mutation
export const ActionSetContractsNegotiableOptions = ({ commit }, contracts) => {
    commit(types.SET_NEGOTIABLE_OPTIONS, contracts);
}

// commit é responsável por chamar a mutation
export const ActionSetContractsAgreementResume = ({ commit }, resume) => {
    commit(types.SET_RESUME, resume);
}

// commit é responsável por chamar a mutation
export const ActionSetDividas = ({ commit }, dividas) => {
    commit(types.SET_DIVIDAS, dividas);
}

export const ActionSetBoletoExpresso = ({ commit }, boletos) => {
    commit(types.SET_BOLETO_EXPRESSO, boletos);
}

export const ActionSetNegociacao = ({ commit }, deal) => {
    commit(types.SET_NEGOCIACAO, deal);
}

export const ActionSetAcordo = ({ commit }, acordo) => {
    commit(types.SET_ACORDO, acordo);
}

export const ActionSetStep = ({ commit }, step) => {
    commit(types.SET_STEP, step);
}

export const ActionSetCurrentComponent = ({ commit }, currentComponent) => {
    commit(types.SET_CURRENTCOMPONENT, currentComponent);
}

export const ActionSetDefaultStates = ({commit}) => {
    commit(types.SET_DIVIDAS, []);
    commit(types.SET_BOLETO_EXPRESSO, []);
    commit(types.SET_ACORDO, {});
    commit(types.SET_STEP, 1);
    commit(types.SET_CURRENTCOMPONENT, "negociar-divida");
}

export const ActionAcceptAgreement = async (context, payload) => {
    user.sendAcceptAgreement.data = payload;
    return await services.http.request(user.sendAcceptAgreement)
        .then(async response => {
            return response.data;
        })
}

export const ActionDownloadV2Boleto = (context, payload) => {
    user.downloadBoleto.data = payload;

    return services.http.request(user.downloadBoleto)
        .then(response => {
            // user.downloadBill.url = 'boleto?ContratoParcela={contratoParcela}&LinhaDigitavel={linhaDigitavel}';
            return response;
        })
        .catch((err) => {
            // user.downloadBill.url = 'boleto?ContratoParcela={contratoParcela}&LinhaDigitavel={linhaDigitavel}';
            return err;
        });
}

export const ActionInsertProposalTricard = ( _, payload) => {
    user.sentProposalTricard.data = payload;
    return services.http.request(user.sentProposalTricard)
        .then((response) => response.data?.results)
        .catch((error) => {
            if (error.data?.message) {
                flashMessages.error(error.data.message);
            }
            throw error;
        })
}
